import { HttpClient } from 'api/http-client';
import { PermissionSet, Team, User } from 'api/models';
import { ProjectPermissionSet } from 'stores/permission-sets';
import { Member, MembersResponse } from './types';

interface ProjectMember {
  user: Pick<User, 'userId'>;
  permissionSet: Pick<ProjectPermissionSet, 'permissionSetType'>;
  joinedAt?: number;
  status?: boolean;
}

export interface InvitedUser extends Omit<Member, 'joinedAt' | 'active'> {
  status?: boolean;
}

export interface ProjectMembership {
  projectId: number;
  members: ProjectMember[];
  teamList?: Team[];
}

export interface MembersV2Response {
  teams: {
    [key: number]: Team;
  };

  users: {
    [key: number]: User;
  };
}

export class MembersAPIClient extends HttpClient {
  public async findAll(): Promise<MembersResponse> {
    return this.get<MembersResponse>('/members');
  }

  public async getMembersV2(): Promise<MembersV2Response> {
    return this.get<MembersV2Response>('/members/projects');
  }

  public getAllProjectMemberships = async () =>
    this.get<ProjectMembership[]>('/projects/get-members');

  public async inviteMembers(data): Promise<InvitedUser[]> {
    return this.post('/members/bulk-action', data);
  }

  public async updateMember(data: {
    user: Pick<User, 'userId' | 'defaultCapacity' | 'capacity'>;
    permissionSet: Pick<PermissionSet, 'permissionSetType'>;
  }): Promise<User> {
    return this.put('/members', data);
  }
}

export const MembersAPI = new MembersAPIClient();

export * from './types';
